import React from "react";
import styles from "./banDetails.module.css";
import { Loader, Modal, Table, ScrollArea } from "@mantine/core";

const createBanRow = (banInfo = {}, index = 1, viewDetails) => {
  const { bannedId, staffMemberId, banStart, banLength, banReason } = banInfo;

  return (
    <tr>
      <td>{banStart}</td>
      <td>{banLength}</td>
      <td>{staffMemberId}</td>
      <td>{banReason}</td>
    </tr>
  );
};

const renderLoadingIcon = () => (
  <center>
    <Loader color="violet" size="xl" />
  </center>
);

export const BanDetails = (props) => {
  const { banDetails, setIsBanDetailVisible } = props;

  return (
    <>
      <Modal
        opened={setIsBanDetailVisible}
        size="400"
        onClose={() => setIsBanDetailVisible(false)}
        title="Ban Details"
        transition="rotate-left"
        transitionDuration={2000}
        centered
      >
        {props.isLoading && renderLoadingIcon()}

        {!props.isLoading && (
          <>
            <div style={{ position: "relative" }}>
              <img
                alt="Steam Profile"
                src={banDetails.avatarUrl}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src =
                    "https://avatars.cloudflare.steamstatic.com/fef49e7fa7e1997310d705b2a6158ff8dc1cdfeb_full.jpg";
                }}
                style={{ border: "1px solid black", "border-radius": "10px" }}
              />
              <ul className={styles.detailsList}>
                <li className={styles.detailEntry}>
                  Banned Id: {banDetails.bannedId}
                </li>
                <li className={styles.detailEntry}>
                  Steam name: {banDetails.steamName}
                </li>
                <li className={styles.detailEntry}>
                  Ban Start: {banDetails.banStart}
                </li>
                <li className={styles.detailEntry}>
                  Ban Length: {banDetails.banLength}
                </li>
                <li className={styles.detailEntry}>
                  Staff Member ID: {banDetails.staffMemberId}
                </li>
              </ul>
              <div style={{ paddingBottom: "20px" }}>
                <center>Ban Reason: {banDetails.banReason}</center>
              </div>
              <ul>
                <li>
                  Other Bans: {props.additionalBans.length}
                  <nav>
                    <Table striped highlightOnHover>
                      <ScrollArea style={{ height: 250 }}>
                        <thead>
                          <th>Ban Date</th>
                          <th>Ban Length</th>
                          <th>Staff Member ID</th>
                          <th>Ban Reason</th>
                        </thead>
                        <tbody>
                          {props.additionalBans.map((additionalBan) =>
                            createBanRow(additionalBan)
                          )}
                        </tbody>
                      </ScrollArea>
                    </Table>
                  </nav>
                </li>
              </ul>
            </div>
          </>
        )}
      </Modal>
    </>
  );
};

export default BanDetails;
